import { GeminiClient } from "./base/GeminiClient";
import { PromptBuilders } from "./utils/PromptBuilders";
import { ResponseParsers } from "./utils/ResponseParsers";
import type {
  ExpandTechnicalDescriptionRequest,
  ExpandTechnicalDescriptionResponse,
  TechnicalSolution,
} from "@/features/Projects";

export class TechnicalSolutionService extends GeminiClient {
  async generateTechnicalSolution(
    technicalDescription: string,
    objectives: string[],
    projectContext?: {
      projectDescription: string;
      projectName: string;
    }
  ): Promise<TechnicalSolution> {
    if (!technicalDescription?.trim()) {
      throw new Error("Descrição técnica é obrigatória");
    }

    try {
      const prompt = PromptBuilders.buildTechnicalSolutionPrompt(
        technicalDescription,
        objectives,
        projectContext
      );
      const response = await this.callGeminiAPI(prompt);

      return ResponseParsers.parseFullTechnicalSolutionResponse(response);
    } catch (error) {
      console.error("Erro ao gerar solução técnica:", error);
      throw new Error("Falha ao processar solução técnica com IA");
    }
  }

  async generateTechnicalSolutionLegacy(
    technicalDescription: string,
    objectives: string[],
    projectContext?: {
      projectDescription: string;
      projectName: string;
    }
  ): Promise<ExpandTechnicalDescriptionResponse> {
    if (!technicalDescription?.trim()) {
      throw new Error("Descrição técnica é obrigatória");
    }

    try {
      const prompt = PromptBuilders.buildTechnicalSolutionPrompt(
        technicalDescription,
        objectives,
        projectContext
      );
      const response = await this.callGeminiAPI(prompt);

      return ResponseParsers.parseTechnicalSolutionResponse(response);
    } catch (error) {
      console.error("Erro ao gerar solução técnica:", error);
      throw new Error("Falha ao processar solução técnica com IA");
    }
  }

  async expandTechnicalDescription(
    request: ExpandTechnicalDescriptionRequest
  ): Promise<ExpandTechnicalDescriptionResponse> {
    return this.generateTechnicalSolutionLegacy(
      request.initialTechnicalDescription,
      request.objectives || [],
      {
        projectDescription: request.projectDescription,
        projectName: "Project"
      }
    );
  }
}